import { ReactElement} from "react";
import {Overlay} from "@/widgets/Overlay";
import {ModalBody, ModalHeader} from "@/widgets/ModalParts";
import DOMPurify from "dompurify";
import QrCodeImage from "@/components/QrCodeImage";
import {useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import { useGetUserProfile } from "@/hooks/useGetUserProfile";

interface Props {
    isBranded?: boolean;
    description?: string;
    targetUrl?: string;
    qrImageUrl?: string;
    isOpen: boolean;
    toggle: () => void;
}

function PromoTokenQrCodeModal(props: Props): ReactElement {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const {data: currentUser} = useGetUserProfile(fullToken);

    return (
        <Overlay
            isOpen={props.isOpen}
            toggle={props.toggle}
            contentClassName="promo-token-qr-code-modal"
            size="sm"
        >
            <ModalHeader
                title="Claim Reward"
                toggle={props.toggle}
            />

            <ModalBody>

                {props.description &&
										<div
										    className="promo-token-external-url-modal_description"
										    // eslint-disable-next-line react/no-danger
										    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(props.description)}}
										/>
                }

                {props.targetUrl &&
										<QrCodeImage href={props.targetUrl}/>
                }

                {props.qrImageUrl &&
										<div className="qr-code-image">
										    <img
										        className="qr-code-image_overlay"
										        src={`${import.meta.env.VITE_CDN_URL}/images/qr-code.png`}
										        alt="QR Overlay"
										    />
										    <img
										        className="qr-code-image_render"
										        src={props.qrImageUrl}
										        alt={props.qrImageUrl}
										    />
										    {props.isBranded &&
                            <div className="qr-code-image_user">
                                @{currentUser?.user?.id}
                            </div>
										    }
										</div>
                }

            </ModalBody>
        </Overlay>
    );
}

export default PromoTokenQrCodeModal;
